<template>
  <div class="result-error-root pt-6">
    <img class="error-icon mx-auto" src="../../assets/common/error.png" />
    <p class="error-title mt-4 mb-6">{{ $t('stamp.scan_unsuccessful') }}</p>
    <div class="hint-wrapper pt-8">
      <h3 class="error-subtitle">{{ $t('stamp.avoid_errors') }}</h3>
      <div class="flex flex-row items-center justify-center">
        <div class="error-item">
          <span>{{ $t('stamp.error_accessories') }}</span>
          <img src="../../assets/stamp/error-accessories.png" alt="" />
        </div>
        <div class="error-item">
          <span>{{ $t('stamp.error_cover_neck') }}</span>
          <img src="../../assets/stamp/error-neck.png" alt="" />
        </div>
        <div class="error-item">
          <span>{{ $t('stamp.error_floor_marks') }}</span>
          <img src="../../assets/stamp/error-floor.png" alt="" />
        </div>
        <div class="error-item">
          <span>{{ $t('stamp.error_postural') }}</span>
          <img src="../../assets/stamp/error-postural.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Error',
};
</script>

<style lang="scss" scoped>
.result-error-root {
  color: #2c2c2c;
}
.error-title {
  color: rgb(179, 34, 35);
  font-size: 30px;
}
.error-subtitle {
  @apply mx-auto mb-4 w-1/2;
  color: rgb(245, 245, 245);
  font-size: 20px;
}
.hint-wrapper {
  background: rgb(44, 44, 44);
}
.error-item {
  @apply flex-1 text-center my-3;
  font-size: 14px;
  line-height: 1.8;
  color: rgb(212, 212, 212);
  span {
    display: inline-block;
    width: 85%;
  }
  img {
    @apply mx-auto mt-4 mb-2;
    width: 80%;
  }
}
.error-icon {
  width: 6%;
}
</style>
